<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <div style="position: relative;">
            <AmountSelectorList />
            <ErrorLabel field="amount" style="text-align: left" />
            </div>
            <FormRow inline>
              <FormCol field="designation" width="half">
              <FormSelect>
                <option value="Any Program">Any Program</option>
                <option value="Campus book Fund">Campus book Fund</option>
                <option value="Programming fund">Programming fund</option>
                <option value="Presence of OU-JLIC couple at a Campus">
                  Presence of OU-JLIC couple at a Campus
                </option>
                <option value="Shabbat Meals">Shabbat Meals</option>
                </FormSelect>
              </FormCol>
            </FormRow>
            <TransactionFee />
          </FormSection>
          <!-- <FormSection title="Donation Frequency">
                  <DonationFrequency />
                </FormSection> -->
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
            <FormRow>
              <FormLabel>
                <input type="checkbox" /> Would you like us to contact you regarding
                naming opportunities?
              </FormLabel>
            </FormRow>
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
            <FormRow>
              <Receipt />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>
